import Api from '../../../api/article/article';

export default {
  namespaced: true,
  state: {
    article: {active: false}
  },
  mutations: {
    setArticle(state, {article}) {
      state.article = article;
    }
  },
  actions: {
    async fetchAll({dispatch}) {
      try {
        const response = await Api.fetchAll();
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetch({dispatch, commit}, {id}) {
      try {
        const response = await Api.fetch(id);
        commit('setArticle', { article: response.data });
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },

    async fetchAddition({dispatch}, {id}) {
      try {
        const response = await Api.fetchAddition(id);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },

    async updateAddition({dispatch}, data) {
      try {
        await Api.updateAddition(data);
        await dispatch('NOTIFY_MSG', 'article.notification.saveAddition', {root: true});
        return Promise.resolve();
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },

    async create({dispatch}, data) {
      try {
        const response = await Api.create(data);
        dispatch('NOTIFY_MSG', 'article.notification.save',
          { root: true});

        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async update({dispatch}, data) {
      try {
        const response = await Api.update(data);
        dispatch('NOTIFY_MSG', 'article.notification.save',
          { root: true});

        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async assignGroups({dispatch}, {articleId, groups}) {
      try {
        await Api.assignGroups(articleId, groups);
        await dispatch('NOTIFY_MSG', 'article.notification.assignGroups',
          { root: true});
        return Promise.resolve();
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async delete({dispatch}, {articleId}) {
      try {
        await Api.delete(articleId);
        await dispatch('NOTIFY_MSG', 'article.notification.deleteArticle',
          { root: true});
        return Promise.resolve();
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
